import React from "react";
import { Dropdown } from "react-bootstrap";

import _ from "lodash";
import cx from "classnames";
import styles from "./styles.module.scss";

const options = [
  { value: "all", label: "All Integrations" },
  { value: "email", label: "Email" },
  { value: "crm", label: "CRM" },
  { value: "chat", label: "Messaging" },
  { value: "marketing_automation", label: "Marketing Automation" },
  { value: "sales_engagement", label: "Sales Engagement" },
  { value: "content_experience", label: "Content Experience" },
  { value: "analytics", label: "Analytics" },
  { value: "notifications", label: "Notifications" },
  { value: "social", label: "Social" }
];

interface IntegrationsOptionsDropdownProps {
  selectedOption: { value: string; label: string } | null;
  setSelectedOption: (option: { value: string; label: string } | null) => void;
}

const IntegrationsOptionsDropdown: React.FC<
  IntegrationsOptionsDropdownProps
> = ({ selectedOption, setSelectedOption }) => {

  const handleSelect = (value: string) => {
    const option = options.find((opt) => opt.value === value) || null;
    setSelectedOption(option);
  };

  return (
    <Dropdown>
      <Dropdown.Toggle className={styles.dropDownButton}>
        {selectedOption ? selectedOption.label : "Choose category"}
        <i className={cx("paperflite-dropdown", styles.icon)}></i>
      </Dropdown.Toggle>

      {_.size(options) > 1 && (
        <Dropdown.Menu
          className={styles.dropDown}
          popperConfig={{
            modifiers: [
              {
                name: "offset",
                options: {
                  offset: [0, 6],
                },
              },
            ],
          }}
        >
          {options.map((option, index) => {
            const selected = option.value === selectedOption?.value;
            return (
              <Dropdown.Item
                key={index}
                className={cx(styles.dropdownItem, {
                  [styles.active]: selected,
                })}
                onClick={() => handleSelect(option.value)}
              >
                {selected ? (
                  <i className="fa-solid fa-circle-check"></i>
                ) : (
                  <i className="fa-regular fa-circle"></i>
                )}
                <span>{option.label}</span>
              </Dropdown.Item>
            );
          })}
        </Dropdown.Menu>
      )}
    </Dropdown>
  );
};

export default IntegrationsOptionsDropdown;
